import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const ROUTE_ANCHOR = "#/";
export const REDUX_ROUTER_NAMESPACE = "router";
export const REDUX_ROUTING_PAGE_NAMESPACE = "routingPage";
export const FULL_REDUX_ROUTER_PAGE_NAMESPACE = createNamespace(REDUX_ROUTER_NAMESPACE);
export const FULL_REDUX_ROUTING_PAGE_NAMESPACE = createNamespace(REDUX_ROUTING_PAGE_NAMESPACE);
